var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.576,
    height: 16.463,
    viewBox: "0 0 11.576 16.463",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "placeholder",
    transform: "translate(-76)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2185",
    "data-name": "Group 2185",
    transform: "translate(76)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2184",
    "data-name": "Group 2184"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1325",
    "data-name": "Path 1325",
    d: "M81.788,0a5.789,5.789,0,0,0-4.924,8.831l4.594,7.4a.482.482,0,0,0,.41.228h0a.482.482,0,0,0,.41-.234l4.477-7.475A5.789,5.789,0,0,0,81.788,0Zm4.144,8.258-4.071,6.8L77.684,8.323a4.826,4.826,0,1,1,8.248-.065Z",
    transform: "translate(-76)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2187",
    "data-name": "Group 2187",
    transform: "translate(78.894 2.894)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2186",
    "data-name": "Group 2186"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1326",
    "data-name": "Path 1326",
    d: "M168.894,90a2.894,2.894,0,1,0,2.894,2.894A2.9,2.9,0,0,0,168.894,90Zm0,4.83a1.936,1.936,0,1,1,1.932-1.936A1.937,1.937,0,0,1,168.894,94.83Z",
    transform: "translate(-166 -90)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.7d946daaab8ce6d0203b1c9ddf9e4cab.svg";
export { ForwardRef as ReactComponent };